import { Menu } from "lucide-react";
import Header from "../Header";
import { Button } from "../ui/button";
import MenuList from "../Menu";
import { Outlet, useLocation } from "react-router";
import { useEffect, useState } from "react";

export const DashboardPageLayout = () => {
  const { pathname } = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="mx-auto max-w-6xl">
      <Header
        menuTrigger={
          <Button
            variant="ghost"
            size="icon"
            className="-mr-2 flex h-8 w-8 items-center justify-center md:hidden"
            onClick={() => setIsMenuOpen(true)}
          >
            <Menu className="h-5 w-5" />
          </Button>
        }
      />
      <MenuList isOpen={isMenuOpen} onOpenChange={setIsMenuOpen} />
      <main className="mt-16 w-full px-3 md:pl-[266px] md:pr-4">
        <Outlet />
      </main>
    </div>
  );
};
